var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronUpRebranding = function SvgChevronUpRebranding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.698 10.204a3 3 0 0 1 4.61 0l3.463 4.156-1.537 1.28-3.463-4.156a1 1 0 0 0-1.537 0L7.771 15.64l-1.537-1.28z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronUpRebranding;